{
  "common.close": "Rufe",
  "common.athleteFallback": "ɗan wasa {id}",
  "splash.title": "{app} — Hoton Motsi na Ayyuka",
  "splash.tagline": "Taswira mai Motsi don Bayananka na&nbsp;Strava",
  "splash.demo": "Nuni",
  "tab.query.title": "Taswirar {name}",
  "tab.query.heading": "Nemo Ayyuka:",
  "tab.query.optDays": "kwanakin baya-bayan nan",
  "tab.query.optActivities": "ayyukan baya-bayan nan",
  "tab.query.optIds": "Lambobin Ayyuka",
  "tab.query.optDates": "Tsakanin Kwanan Wata",
  "tab.query.idsPlaceholder": "shigar da lambobin ayyuka a nan",
  "tab.query.after": "Bayan:",
  "tab.query.before": "Kafin:",
  "tab.query.autozoom": "Zuƙowa <i class=\"hf hf-bullseye\"></i> kai tsaye zuwa sakamakon bayan shigo da su",
  "tab.query.queryButton": "<i class=\"hf hf-cloud-download\"></i> Nemo",
  "tab.query.createAccount": "Buɗe asusu da/ko shiga.",
  "tab.query.sports": "Wasanni:",
  "tab.query.allSports": "Duk wasanni",
  "tab.query.sportsExcept": "Duk banda",
  "tab.query.sportsNone": "Babu",
  "tab.query.loadingSports": "Ana loda wasanni…",
  "tab.query.sportsFailed": "An kasa loda wasannin wannan taswira",
  "tab.query.noSports": "Babu ayyuka tukuna",
  "tab.activities.title": "Ayyukan da ake Nunawa",
  "tab.activities.clearSelection": "Share Zaɓi",
  "tab.activities.renderSelected": "Nuna waɗanda aka zaɓa",
  "tab.activities.zoomToSelection": "<i class=\"fas fa-search-plus\"></i> <i class=\"far fa-object-group\"></i> <i class=\"fas fa-search-minus\"></i> Zuƙowa zuwa zaɓi",
  "tab.controls.title": "Saitunan Layi",
  "tab.controls.timescale": "Ma'aunin lokaci <i>&tau;</i>",
  "tab.controls.timescaleHint": "saurin kunnawa",
  "tab.controls.period": "Zagaye <i>T</i>",
  "tab.controls.periodHint": "aiki ~ samfuri",
  "tab.controls.dotSize": "Girman ɗigo",
  "tab.controls.pathWidth": "Faɗin hanya",
  "tab.controls.pathWidthHint": "sifili yana ɓoye hanyoyi",
  "tab.controls.colors": "Launuka",
  "tab.controls.colorsHint": "juya launuka",
  "tab.controls.shadows": "Inuwa",
  "tab.profile.loginTitle": "Shiga",
  "tab.profile.anonNote": "Shiga da Strava don ganin ayyukanka, da kuma sarrafa asusunka na Heatflask.",
  "tab.profile.loginLink": "Shiga da Strava",
  "tab.profile.editOnStrava": "Gyara bayananka a Strava",
  "tab.profile.indexNote": "Muna adana taƙaitaccen bayanin ayyukanka don samun su da sauri.",
  "tab.profile.viewIndex": "Duba jeri",
  "tab.profile.sharedMaps": "Taswirorin da aka Raba",
  "tab.profile.sharedMapsNote": "A kashe: kai kaɗai kake ganin ayyukanka a Heatflask. A kunne: duk wanda ke da mahaɗin taswirarka zai iya ganin ayyukan da ka bayyana wa jama'a a Strava. Ayyukanka na sirri suna nan naka a kowane hali. <a id=\"profile-privacy-link\" href=\"#\" target=\"_blank\" rel=\"noopener\">Yadda sirri ke aiki</a>",
  "tab.profile.logout": "Fita",
  "tab.profile.deleteAccount": "Goge Asusu",
  "tab.profile.deleteConfirm": "Goge asusunka na Heatflask?\n\nWannan zai cire ayyukanka da aka adana kuma ya soke izinin Heatflask ga bayananka na Strava. Ba za a iya mayar da shi ba.",
  "tab.profile.languageHeading": "Harshe",
  "tab.profile.languageAuto": "Kai tsaye",
  "tab.profile.translateNote": "<a id=\"translate-link\" target=\"_blank\" rel=\"noopener\">Taimaka mana gyara ko ƙara fassarori!</a>",
  "tab.profile.unitsHeading": "Ma'auni",
  "tab.profile.unitsAuto": "Kai tsaye",
  "tab.profile.unitsMetric": "Metric (km, m)",
  "tab.profile.unitsImperial": "Imperial (mil, ƙafa)",
  "tab.profile.textSizeHeading": "Girman rubutu",
  "tab.profile.textSmaller": "Ƙarami",
  "tab.profile.textReset": "Na yau da kullum",
  "tab.profile.textLarger": "Babba",
  "tab.profile.mapDefaultsHeading": "Tsoffin saitunan taswira",
  "tab.profile.mapDefaultsNote": "Fara da wannan taswirar tushe, yanayin ƙasa da saitunan layi duk lokacin da ka buɗe taswirar da mahaɗinta bai saita nasa ba. Mahaɗan da kake rabawa har yanzu suna nuna ainihin abin da kake gani.",
  "tab.profile.mapDefaultsSave": "Ajiye a matsayin tsoffin saitunana",
  "tab.profile.mapDefaultsForget": "Manta",
  "tab.info.title": "Bayani",
  "tab.info.controlsHeading": "Sarrafawa",
  "tab.info.shiftDragKey": "<kbd>Shift</kbd> + ja",
  "tab.info.shiftDragDesc": "Zaɓi ayyuka a cikin akwati. A allon taɓawa, fara taɓa <i class=\"hf-object-group\"></i>, sannan ka ja da yatsa ɗaya. Aikin da aka zaɓa na ƙarshe yana nuna cikakken bayaninsa, kuma jerin ayyuka zai gungura zuwa gare shi.",
  "tab.info.ctrlDragKey": "<kbd>Ctrl</kbd> + ja",
  "tab.info.ctrlDragDesc": "Juya da karkata taswira a 3D, ko ka yi amfani da yatsu biyu",
  "tab.info.spaceKey": "<kbd>Space</kbd>",
  "tab.info.spaceDesc": "Buɗe ko rufe gefen shafi",
  "tab.info.arrowsKey": "<kbd>&uarr;</kbd> <kbd>&darr;</kbd>",
  "tab.info.arrowsDesc": "Shafin gefe na baya ko na gaba",
  "tab.info.escKey": "<kbd>Esc</kbd>",
  "tab.info.escDesc": "Rufe gefen shafi",
  "tab.info.liveUrlHeading": "Adireshi mai Rai",
  "tab.info.liveUrlDesc": "Ana ajiye ganin taswira da saitunan motsi a cikin adireshin shafin, don haka duk wanda ka raba masa zai ga abu ɗaya.",
  "tab.info.videoHeading": "Fitar da Bidiyo",
  "tab.info.videoDesc": "Maɓallin <i class=\"hf-video-camera\"></i> yana naɗar motsin a matsayin MP4: taɓa shi, daidaita akwatin a kan ɓangaren taswirar da kake so, sannan ka sake taɓawa don naɗa. Ana naɗar cikakken zagaye ɗaya na motsin, don haka bidiyon yana maimaituwa ba tare da tsinkewa ba; zagayen da ya fi daƙiƙa {max} (bidiyo mafi tsawo da Strava ke karɓa) za a yanke shi a {max}.",
  "tab.info.contributeHeading": "Ba da Gudummawa",
  "tab.info.sponsor": "<i class=\"hf-github\"></i> Tallafa mana a GitHub",
  "tab.info.contactsHeading": "Tuntuɓa",
  "map.basemapAndTerrain": "Taswirar tushe da yanayin ƙasa",
  "map.pauseAnimation": "Dakatar da motsi",
  "map.resumeAnimation": "Ci gaba da motsi",
  "capture.record": "Naɗi bidiyo (zagaye na daƙ. {period})",
  "capture.recordTruncated": "Naɗi bidiyo (zagaye ɗaya daƙ. {period} ne; daƙ. {max} na farko kawai za a naɗa)",
  "capture.recordArea": "Naɗi yankin da ke cikin akwatin",
  "capture.stop": "Daina naɗi",
  "capture.selectionTooSmall": "zaɓin ya yi ƙanƙanta",
  "capture.saved": "an ajiye {name} ({size})",
  "capture.cancelled": "an soke naɗi",
  "capture.failed": "naɗi ya gaza: {error}",
  "capture.loadingEncoder": "ana loda mai sauya bidiyo…",
  "capture.waitingForMap": "ana jiran taswira ta loda…",
  "capture.encoding": "ana sauyawa… {percent}%",
  "capture.finalizing": "ana kammalawa…",
  "share.title": "Raba hanyar haɗi zuwa wannan taswira",
  "share.copied": "an kwafi hanyar haɗi",
  "share.copiedUnshared": "an kwafi hanyar haɗi — amma ba a raba taswirarka ba, don haka babu wani da zai iya buɗe ta. Kunna “Taswirorin da aka Raba” don canza hakan.",
  "share.unshared": "Ba a raba taswirarka ba, don haka babu wani da zai iya buɗe wannan hanyar haɗi. Kunna “Taswirorin da aka Raba” don canza hakan.",
  "share.copyThis": "Kwafi wannan hanyar haɗi:",
  "update.available": "Akwai sabon sigar Heatflask.",
  "update.reload": "Sake lodawa",
  "import.title": "Ana Shigo da su",
  "import.stop": "Tsaya",
  "import.stopping": "ana tsayawa…",
  "import.contacting": "ana tuntuɓar Strava…",
  "import.countOf": "Ayyuka: {received} cikin {total}",
  "import.count": "Ayyuka: {received}",
  "import.waitStrava": "An dakata har zuwa {time} saboda iyakar saukewa ta Strava. Ka bar wannan shafi a buɗe; sake lodawa ba zai ƙara sauri ba.",
  "import.waitRationed": "Saukewar gaggawa ta yau ta ƙare. Sauran za su ci gaba da {time}, a hankali. Ka bar wannan shafi a buɗe.",
  "import.dailyLimit": "Iyakar saukewa ta yau da kullum ta Strava ta cika. Sake gwadawa bayan {time}.",
  "import.dailyRationed": "Rabonka na saukewa daga Strava na yau ya ƙare. Sake gwadawa bayan {time}.",
  "import.noActivitiesYet": "Asusunka na Strava ba shi da wani aiki tukuna. Yi rikodin ko ɗora ɗaya a Strava, zai bayyana a nan.",
  "table.noActivities": "babu ayyuka",
  "table.untitled": "(babu suna)",
  "activities.pageTitle": "{app} — Jerin Ayyuka",
  "activities.heading": "Jerin Ayyuka",
  "activities.fetching": "Ana ɗauko ayyuka...",
  "activities.rateLimit": "An kai iyakar buƙatun Strava; za a ci gaba da ƙarfe {time}",
  "activities.noData": "Yi haƙuri, babu bayanai &#128577;",
  "activities.colServerCache": "An adana hanyar a sabar (Mongo)",
  "activities.colBrowserCache": "An adana hanyar a wannan burauza",
  "activities.cachedServer": "An adana hanyar {id} a sabar",
  "activities.notCachedServer": "Ba a adana hanyar {id} a sabar ba",
  "activities.cachedBrowser": "An adana hanyar {id} a wannan burauza",
  "activities.notCachedBrowser": "Ba a adana hanyar {id} a wannan burauza ba",
  "sport.AlpineSki": "Wasan kankara na tsaunuka",
  "sport.BackcountrySki": "Wasan kankara a daji",
  "sport.Badminton": "Badminton",
  "sport.Basketball": "Ƙwallon kwando",
  "sport.Canoeing": "Tuƙin kwale-kwale",
  "sport.Cricket": "Kiriket",
  "sport.Crossfit": "Crossfit",
  "sport.Dance": "Rawa",
  "sport.EBikeRide": "Hawan keken lantarki",
  "sport.Elliptical": "Injin elliptical",
  "sport.EMountainBikeRide": "Hawan keken tsauni na lantarki",
  "sport.Golf": "Golf",
  "sport.GravelRide": "Hawan hanyar tsakuwa",
  "sport.Handcycle": "Keken hannu",
  "sport.HighIntensityIntervalTraining": "HIIT",
  "sport.Hike": "Yawo a tsauni",
  "sport.IceSkate": "Zamiya a kan ƙanƙara",
  "sport.InlineSkate": "Zamiya da ƙafafun layi",
  "sport.Kayaking": "Tuƙin kayak",
  "sport.Kitesurf": "Kitesurf",
  "sport.MountainBikeRide": "Hawan keken tsauni",
  "sport.NordicSki": "Wasan kankara na Nordic",
  "sport.Padel": "Padel",
  "sport.PhysicalTherapy": "Maganin gyaran jiki",
  "sport.Pickleball": "Pickleball",
  "sport.Pilates": "Pilates",
  "sport.Racquetball": "Racquetball",
  "sport.Ride": "Hawan keke",
  "sport.RockClimbing": "Hawan dutse",
  "sport.RollerSki": "Roller ski",
  "sport.Rowing": "Tuƙin jirgin ruwa",
  "sport.Run": "Gudu",
  "sport.Sail": "Tuƙin jirgin ruwa mai filafili",
  "sport.Skateboard": "Allon zamiya",
  "sport.Snowboard": "Allon ƙanƙara",
  "sport.Snowshoe": "Takalman ƙanƙara",
  "sport.Soccer": "Ƙwallon ƙafa",
  "sport.Squash": "Squash",
  "sport.StairStepper": "Injin matakala",
  "sport.StandUpPaddling": "Tuƙi a tsaye",
  "sport.Surfing": "Wasan igiyar ruwa",
  "sport.Swim": "Ninƙaya",
  "sport.TableTennis": "Ƙwallon tebur",
  "sport.Tennis": "Tanis",
  "sport.TrailRun": "Gudun hanyar daji",
  "sport.Velomobile": "Velomobile",
  "sport.VirtualRide": "Hawan keke na kama-da-wane",
  "sport.VirtualRow": "Tuƙi na kama-da-wane",
  "sport.VirtualRun": "Gudu na kama-da-wane",
  "sport.Volleyball": "Ƙwallon raga",
  "sport.Walk": "Tafiya",
  "sport.WeightTraining": "Horon nauyi",
  "sport.Wheelchair": "Keken guragu",
  "sport.Windsurf": "Windsurf",
  "sport.Workout": "Motsa jiki",
  "sport.Yoga": "Yoga"
}
